import Vue from 'vue';
import Vuex from 'vuex';
import VueResource from 'vue-resource'

Vue.use(Vuex, VueResource);

export const store = new Vuex.Store({
  state: {
    menuDown: false,
    topitems: [],
    infoitems: [],
    subitems:[],
    venues: [],
    ribocaitems: [],
    destUrl:'__/__',
    destChange:false,
    dropdownMenu:false,
    transitionState:false,
    langUrl:'en',
    rootSection: 'home',
    parentSection:'',
    navHeight:60,
    currentSection:'',
    currentRootSection:'home',
    subDropdownMenu:false,
    baseUrl: 'https://archive.rigabiennial.com/',
    favArtists:[],
    favVenues:[],
    favEvents:[],
    language:''
  },
  getters: {
    getBaseUrl(state) {
      return state.baseUrl;
    },
    getDestUrl(state) {
      return state.destUrl;
    },
    getDestChange(state) {
      return state.destChange;
    },
    getMenuState(state) {
      return state.menuDown;
    },
    getVenues(state) {
      return state.currentRootSection;
    },
    getTransitionState(state) {
      return state.transitionState;
    },
    getLangState(state) {
      return state.langUrl;
    },
    getFavArtists(state) {
      return state.favArtists;
    },
    getFavEvents(state) {
      return state.favEvents;
    },
    getFavVenues(state) {
      return state.favVenues;
    },
    getLanguage(state) {
      return state.language;
    }
  },
  mutations: {
    setDestUrl: (state, payload) => {
      state.destUrl = payload;
    },
    setDestChange: (state, payload) => {
      state.destChange = payload;
    },
    setMenuState: (state) => {
      state.menuDown = !state.menuDown;
    },
    setVenues: (state, payload) => {
      state.venues = payload;
    },
    setTransitionState: (state) => {
      state.transitionState = !state.transitionState;
    },
    setLangState: (state, payload) => {
      state.langUrl = payload;
    },
    setFavArtists: (state, payload) => {
      state.favArtists = payload;
    },
    setFavEvents: (state, payload) => {
      state.favEvents = payload;
    },
    setFavVenues: (state, payload) => {
      state.favVenues = payload;
    },
    addFavArtists: (state, payload) => {
      state.favArtists.push(payload);
      localStorage.setItem('favArtists',JSON.stringify(state.favArtists));
    },
    removeFavArtists: (state, payload) => {
      state.favArtists.splice(payload,1);
      localStorage.setItem('favArtists',JSON.stringify(state.favArtists));
    },
    addFavVenues: (state, payload) => {
      state.favVenues.push(payload);
      localStorage.setItem('favVenues',JSON.stringify(state.favVenues));
    },
    removeFavVenues: (state, payload) => {
      state.favVenues.splice(0,1);
      localStorage.setItem('favVenues',JSON.stringify(state.favVenues));
    },
    addFavEvents: (state, payload) => {
      state.favEvents.push(payload);
      localStorage.setItem('favEvents',JSON.stringify(state.favEvents));
    },
    removeFavEvents: (state, payload) => {
      state.favEvents.splice(0,1);
      localStorage.setItem('favEvents',JSON.stringify(state.favEvents));
    },
    setLanguage: (state, payload) => {
      state.language = payload;
    }
  },
  actions: {
    setDestUrl: function({commit}, payload) {
      commit('setDestUrl', payload);
    },
    setDestChange: function({commit}, payload) {
      commit('setDestChange', payload);
    },
    setMenuState: function({commit}) {
      commit('setMenuState');
    },
    setVenues: function({commit}, payload) {
      commit('setVenues', payload);
    },
    setTransitionState: function({commit}) {
      commit('setTransitionState');
    },
    setLangState: function({commit}, payload) {
      commit('setLangState', payload);
    },
    setFavArtists: function({commit}, payload) {
      commit('setFavArtists', payload);
    },
    setFavEvents: function({commit}, payload) {
      commit('setFavEvents', payload);
    },
    setFavVenues: function({commit}, payload) {
      commit('setFavVenues', payload);
    },
    setLanguage: function({commit}, payload) {
      commit('setLanguage', payload);
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js